<style scoped>
</style>

<template>
  <div class="vue-box">
    <div class="c-panel">

      <!-- 参数栏 -->
      <div class="c-title">{{params.name}}</div>
      <el-form size="mini" :inline="true" @submit.native.prevent >
        <el-select style="margin-right: 20px"
            v-model="stuId"
            filterable
            remote
            reserve-keyword
            size="mini"
            placeholder="请输入关键词"
            :remote-method="queryStudentList"
            :loading="loading">
          <el-option
              v-for="item in stuList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <el-form-item style="min-width: 0px;">
          <el-button type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
        </el-form-item>
        <el-form-item style="min-width: 0px;">
          <el-button type="primary" icon="el-icon-search" @click="f5()">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- 数据列表 -->
      <div class="c-title">[{{params.name}}] 学生列表</div>
      <el-table :data="dataList" size="mini">
        <el-table-column label="姓名" width="150px">
          <template slot-scope="s"><span>{{s.row.name}}</span></template>
        </el-table-column>
        <el-table-column label="性别" width="150px">
          <template slot-scope="s"><span>{{s.row.sex==0?'男':'女'}}</span></template>
        </el-table-column>
        <el-table-column label="所属校区" width="300px">
          <template slot-scope="s"><span>{{getCampusName(s.row.campus)}}</span></template>
        </el-table-column>
        <el-table-column label="加入日期" width="150px">
          <template slot-scope="s"><span>{{sa.forDate3(s.row.createTime, 2)}}</span></template>
        </el-table-column>


        <el-table-column label="操作" width="240px">
          <template slot-scope="s">
            <!--            <el-button class="c-btn" type="success"  icon="el-icon-view" @click="openClazzCard(s.row)">课表</el-button>-->
<!--            <el-button class="c-btn" type="primary" icon="el-icon-edit" @click="update(s.row)">修改</el-button>-->
            <el-button class="c-btn" type="danger" icon="el-icon-delete" @click="del(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>


  </div>
</template>

<script>

export default {
  props: ['params'],
  components: {
  },

  data() {
    return {
      stuId:'',
      loading:false,
      p: {		// 查询参数
      },
      dataList: [],		// 数据集合
      campusList:[], //校区列表
      stuList:[],//学生列表
    }
  },
  methods: {
    // 刷新
    f5: function(){
      let data = {
        clazzId:this.params.id
      }
      this.sa.ajax('api/psdAdmin/clazz/getStudentList',
          data,
          function(res){
            if(res.code == 0) {
              this.dataList = res.data;	// 数据
              console.log('班级学生',res.data);
            }else{
              this.dataList=[];
              this.sa.error(res.msg || '学生列表获取失败');
            }
          }.bind(this)/*, {res: mockDataList}*/);
    },
    // 添加
    add: function () {
      let _this = this;

      this.sa.ajax('api/psdAdmin/clazz/addStuToClazz',
          {
            clazzId:this.params.id,
            stuId:this.stuId
          },
          function(res){
            console.log(res);
            if(res.code==0){
              _this.f5();
            }else{
              _this.sa.error(res.msg || '学生添加失败');
            }
          }.bind(this));

    },
    getCampusList:function (){
      this.sa.ajax('api/psdAdmin/campus/getList',
          {},
          function(res){
            this.campusList = res.data;
            console.log('校区',res.data);
          }.bind(this),{async:false});
    },
    getCampusName: function (value) {
      for(let i=0;i<this.campusList.length;i++){
        if(this.campusList[i].id == value){
          return this.campusList[i].name;
        }
      }
      return value;
    },
    // 删除
    del: function (data) {
      this.sa.confirm('是否删除，此操作不可撤销', function() {
        this.sa.ajax('api/psdAdmin/clazz/delStuToClazz',
            {
              clazzId:this.params.id,
              stuId:data.id
            },
            function(res) {
            if(res.code == '0'){
              this.sa.arrayDelete(this.dataList, data);
              this.sa.ok('删除成功');
            }else{
              this.sa.error(res.msg || '学生删除失败');
            }

        }.bind(this))
      }.bind(this));
    },
    queryStudentList(name){
        this.loading = true;
        let data = {
          name:name,
          pageNum:0,
          pageSize:20,
          campus:'',
          status:'0'
        }
        this.sa.ajax('api/psdAdmin/stu/getStudentList',
            data,
            function(res){
              if(res.code == 0) {
                this.stuList = res.data.data;	// 数据
              }else{
                this.stuList=[];
                this.sa.error(res.msg || '会员列表获取失败');
              }
              this.loading = false;
            }.bind(this)/*, {res: mockDataList}*/);
    }
  },
  created: function(){
    this.queryStudentList();
    this.getCampusList();
    this.f5();
  },
  filters: {

  }
}
</script>
